var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstoreSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.5C16.5 14.121 17.621 13 19 13C20.379 13 21.5 14.121 21.5 15.5C21.5 16.879 20.379 18 19 18C17.621 18 16.5 16.879 16.5 15.5ZM21 19H17C15.346 19 14 20.346 14 22V24H16V22C16 21.449 16.448 21 17 21H21C21.552 21 22 21.449 22 22V24H24V22C24 20.346 22.654 19 21 19ZM21.7 0H2.299L0.025 9.891L0 11.038C0 12.034 0.385 12.934 1 13.63V20.999C1 22.653 2.346 23.999 4 23.999H12V21.999H4C3.449 21.999 3 21.55 3 20.999V14.858C3.322 14.941 3.653 14.999 4 14.999H5C6.194 14.999 7.254 14.451 7.981 13.605C8.708 14.452 9.767 14.999 10.962 14.999H13.039C13.587 14.999 14.108 14.886 14.583 14.682C14.838 13.294 15.734 12.143 16.949 11.515C16.971 11.344 17.001 11.175 17.001 10.998H15.001C15.001 12.12 14.14 12.998 13.039 12.998H10.962C9.862 12.998 9.001 12.12 9.001 10.998H6.962C6.962 12.12 6.101 12.998 5.001 12.998H4.001C2.879 12.998 2.001 12.137 2.001 11.037V10.227L3.892 2H7V6H9V2H15V6H17V2H20.108L22 10.229V11.039C22 11.38 21.908 11.692 21.758 11.969C22.304 12.396 22.748 12.94 23.05 13.572C23.634 12.883 24 12.007 24 11.039V10.116L21.7 0Z",
    fill: "#0084D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstoreSales);
export default __webpack_public_path__ + "static/media/instore-sales.c61702b60c1d3c43f6d5bf6f42305217.svg";
export { ForwardRef as ReactComponent };